import {Map} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';

import * as Actions from './actions';
import {type OrganizationPerson} from './model';

export type OrganizationPersonsState = Map<string, OrganizationPerson>;

export default makeReducer<OrganizationPersonsState>(
    [
        match(Actions.createSuccess, (state, {payload}) =>
            state.update(payload.person.organizationPersonId, () => payload.person),
        ),
        match(Actions.updateSuccess, (state, {payload}) => {
            const {oldPerson, newPerson} = payload;
            const removed = state.delete(oldPerson.organizationPersonId);
            return removed.update(newPerson.organizationPersonId, () => newPerson);
        }),
        match(Actions.fetchSuccess, (state, {payload}) =>
            state.update(payload.person.organizationPersonId, () => payload.person),
        ),
        match(Actions.fetchAllSuccess, (state, {payload}) => {
            const updates = Map(payload.persons.map(p => [p.organizationPersonId, p]));
            return state.merge(updates);
        }),
        match(Actions.deletePersonSuccess, (state, {payload}) => state.delete(payload.person.organizationPersonId)),
    ],
    Map<string, OrganizationPerson>(),
);
